import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Spinner,
  Text,
  Button,
  Box,
  VStack,
  Flex,
} from '@chakra-ui/react';
import { QrReader } from '@blackbox-vision/react-qr-reader';

interface QRCodeScannerProps {
  isOpen: boolean;
  onClose: () => void;
  onScan: (data: string) => void;
}

const QRCodeScanner: React.FC<QRCodeScannerProps> = ({ isOpen, onClose, onScan }) => {
  const [isScanning, setIsScanning] = useState(true);

  // Quando o modal fecha, interrompe o stream da câmera
  useEffect(() => {
    if (!isOpen) {
      stopStream();
      setIsScanning(true);
    }
  }, [isOpen]);

  const handleResult = (result: any, error: any) => {
    if (result && isScanning) {
      setIsScanning(false);
      onScan(result.getText());
      onClose();
      setTimeout(() => setIsScanning(true), 3000);
    }
    if (error && error.name !== 'NotFoundException') {
      console.error("Erro ao escanear QRCode:", error);
    }
  };

  // Função para interromper o stream da câmera
  const stopStream = () => {
    const video = document.querySelector('video');
    if (video && video.srcObject) {
      const stream = video.srcObject as MediaStream;
      stream.getTracks().forEach(track => track.stop());
      video.srcObject = null;
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={() => { stopStream(); onClose(); }} isCentered>
      <ModalOverlay />
      <ModalContent maxW="400px" borderRadius="lg" p={3}>
        <ModalHeader textAlign="center">📷 Escanear QRCode</ModalHeader>
        <ModalCloseButton onClick={() => { stopStream(); onClose(); }} />
        <ModalBody>
          <VStack spacing={4}>
            <Box
              w="100%"
              h="250px"
              borderRadius="lg"
              overflow="hidden"
              boxShadow="lg"
              border="3px solid #3182CE"
            >
              {isScanning ? (
                <QrReader
                  onResult={handleResult}
                  constraints={{ facingMode: 'environment' }}
                  containerStyle={{ width: '100%', height: '100%' }}
                  videoContainerStyle={{ width: '100%', height: '100%' }}
                />
              ) : (
                <Flex align="center" justify="center" h="100%">
                  <Spinner size="lg" color="blue.500" />
                  <Text ml={2} fontSize="sm">Processando QRCode...</Text>
                </Flex>
              )}
            </Box>
            <Text fontSize="sm" color="gray.600" textAlign="center">
              Posicione o QRCode dentro da área de leitura.
            </Text>
            <Button colorScheme="red" onClick={() => { stopStream(); onClose(); }} width="100%">
              Fechar Scanner
            </Button>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default QRCodeScanner;
